<template>
  <div>
    <template v-if="getSpaceplans === null">
      <loader />
    </template>
    <template v-else>
      <template v-if="getSpaceplans.length > 0">
        <tile-grid>
          <space-plan-tile
            v-for="spaceplan in getSpaceplans"
            :key="spaceplan.id"
            :spaceplan="spaceplan"
          />
        </tile-grid>
      </template>
      <template v-else>
        {{ $t('no-vizualizations') }}
      </template>
      <space-plan-modal-form ref="spacePlanModalForm" />
    </template>
  </div>
</template>

<script>
import eventBus from '@/components/utils/slideout-panel/eventBus';
import BreadcrumbsManager from '@/mixins/BreadcrumbsManager';
import { mapGetters, mapActions } from 'vuex';
import SpacePlanTile from '@/components/spaceplan/SpacePlanTile.vue';
import SpacePlanModalForm from '@/components/spaceplan/SpacePlanModalForm.vue';
import Loader from '@/components/utils/Loader.vue';
import TileGrid from '@/components/utils/TileGrid';

export default {
  name: 'Spaceplans',
  mixins: [
    BreadcrumbsManager,
  ],
  data() {
    return {
      breadcrumbs: [
        {
          text: this.$t('vizualizations'),
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      'getSpaceplans',
    ]),
  },
  methods: {
    ...mapActions([
      'loadSpaceplans',
    ]),
    addSpacePlanClicked() {
      this.$refs.spacePlanModalForm.show();
    },
  },
  components: {
    TileGrid,
    SpacePlanTile,
    SpacePlanModalForm,
    Loader,
  },
  created() {
    eventBus.$on('addSpacePlanClicked', this.addSpacePlanClicked);
  },
  destroyed() {
    eventBus.$on('addSpacePlanClicked', this.addSpacePlanClicked);
  },
  mounted() {
    this.loadSpaceplans();
  },
};
</script>

<style scoped>

</style>
